import service from "../utils/axios";

// 订单列表
const getOrders = (data) => {
  return service.get("/orders", { params: data });
};

// 订单详情
const getOrderDetail = (order_no) => {
  return service.get(`/orders/${order_no}`);
};

// 商品列表
const getGoods = (data) => {
  return service.get("/goods", { params: data });
};

// 创建订单
const postOrders = (data) => {
  return service.post("/orders", data);
};

// 查询支付宝订单状态
const getOrdersPayStatus = (data) => {
  return service.get(`/orders/pay/${data}/status`);
};

// 查询订单状态（微信 + 支付宝）
const getOrdersStatus = (data) => {
  return service.get(`/orders/${data.order_no}/status`, {
    params: { platform: data.platform },
  });
};

// 继续付款
const getOrdersRepay = (data) => {
  return service.post(`/orders/${data.order_no}/repay`, {
    return_url: data.return_url,
  });
};

// 取消订单
const getOrdersCancel = (data) => {
  return service.post(`/orders/${data}/cancel`);
};

// 获取活动列表
const getActivity = (data) => {
  return service.get(`/activity_packages`, { params: data });
};

// 获取活动套餐图片
const getActivityImage = (id) => {
  return service.get(`/activity_packages/${id}/image`);
};

// 获取活动套餐图片
const getActivityCanBuy = (id) => {
  return service.get(`/activity_packages/${id}/can_buy`);
};

// 获取活动详情
const getActivityDetail = (id) => {
  return service.get(`/activity_packages/${id}`);
};

// 提交开票申请
const submitInvoice = (data) => {
  return service.post("/invoice", data);
};

// QQ 社群信息
const getQQGroupInfo = () => {
  return service.get("/sys/setting", { params: { name: "qq_groups" } });
};

export {
  getOrders,
  getOrderDetail,
  getGoods,
  postOrders,
  getOrdersPayStatus,
  getOrdersStatus,
  getOrdersRepay,
  getOrdersCancel,
  getActivity,
  getActivityImage,
  getActivityCanBuy,
  getActivityDetail,
  submitInvoice,
  getQQGroupInfo,
};
